import * as XLSX from 'xlsx'
import { PRODUCTION_PRINT_COLUMNS, type SalesPlanningRow } from './salesPlanningGridUtils'

function display(value: unknown, row: SalesPlanningRow, key: string, index: number, fallbackDimUnit: 'mm' | 'in'): string | number {
  const column = PRODUCTION_PRINT_COLUMNS[index]
  if (['w', 'd', 'h'].includes(key) && value != null) {
    const number = Number(value)
    const unit = row.dim_unit === 'mm' ? 'mm' : row.dim_unit === 'inch' ? 'in' : fallbackDimUnit
    const displayed = unit === 'in' ? number / 25.4 : number
    return unit === 'in' ? `${Number(displayed.toFixed(1)).toFixed(1)}\"` : `${Math.round(displayed)} mm`
  }
  if (column?.formatter) return column.formatter(value, row, index)
  if (value == null) return ''
  if (key.startsWith('d_')) {
    const date = String(value).slice(0, 10)
    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }
  return value as string | number
}

export function createProductionWorkbook(lines: SalesPlanningRow[], dimUnit: 'mm' | 'in' = 'in'): XLSX.WorkBook {
  const columns = PRODUCTION_PRINT_COLUMNS
  const active = lines.filter((line) => line.line_status !== 'cancelled')
  const rows: Array<Array<string | number>> = [columns.map((column) => column.label)]
  active.forEach((line, rowIndex) => {
    rows.push(columns.map((column, columnIndex) => display(
      column.key === 'id' ? rowIndex + 1 : line[column.key],
      line,
      column.key,
      columnIndex,
      dimUnit,
    )))
  })
  const totalQty = active.reduce((sum, line) => sum + Number(line.quantity || 0), 0)
  const totalContainers = active.reduce((sum, line) => sum + Number(line.containers_qty || 0), 0)
  const total = Array<string | number>(columns.length).fill('')
  total[0] = 'TỔNG'
  total[12] = totalQty
  total[13] = totalContainers
  rows.push(total)
  const worksheet = XLSX.utils.aoa_to_sheet(rows)
  worksheet['!cols'] = columns.map((column) => ({ wch: typeof column.width === 'number' ? Math.max(10, Math.round(column.width / 8)) : 16 }))
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Lệnh sản xuất')
  return workbook
}
